module.exports = __webpack_public_path__ + "static/media/Brain.1155071f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/about/Brain.webp
// module id = 593
// module chunks = 8